module.exports = __webpack_public_path__ + "static/img/rank_268.46f70e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_268.png
// module id = U9Yr
// module chunks = 1